import BaseService from '@/ecm/common/BaseService.js'

class SearchService {
  baseUrl = 'search';

  getFullText = (pattern) => BaseService.post({ url: `${this.baseUrl}/fulltext`, data: pattern });
  getAdvanced = (pattern) => BaseService.post({ url: `${this.baseUrl}/advanced`, data: pattern });
  getDocuments = (documentIds) => BaseService.post({ url: `${this.baseUrl}/objects/${documentIds}` });
  getBaskets = (basketId) => BaseService.post({ url: `${this.baseUrl}/basket/${basketId}` });
  getDistributions = (distributionType) => BaseService.post({ url: `${this.baseUrl}/distribution/${distributionType}` });
  getUserSearch = (searchId) => BaseService.post({ url: `${this.baseUrl}/user-saved/${searchId}` });
  getAdvSearchFields = (contentTypeIDs) => BaseService.get({ url: `${this.baseUrl}/get-fields/${contentTypeIDs}` });
  getSearchResults = (searchRequest) => BaseService.post({ url: `${this.baseUrl}/get-search-results`, data: searchRequest });
  saveUserSearch = (userSearch) => BaseService.post({ url: `${this.baseUrl}/save-user-search`, data: userSearch });
  deleteUserSearch = (id) => BaseService.post({ url: `${this.baseUrl}/delete-user-search/${id}` });
  getUserSearchGroupAndSortSettings = (id) => BaseService.get({ url: `${this.baseUrl}/get-user-search-group-and-sort-settings/${id}` });
  validateCriteria = (conditionStr) => BaseService.post({ url: `${this.baseUrl}/validate-criteria`, data: conditionStr });
  getDocumentsByCriteria = (searchRequest) => BaseService.post({ url: `${this.baseUrl}/get-document-by-criteria`, data: searchRequest });
  getUserSearchDocumentCount = (dashboardItemDTO) => BaseService.post({ url: `${this.baseUrl}/get-user-search-document-count`, data: dashboardItemDTO });
}

export default new SearchService()
